import { Box } from '@vp/swan';
import React, { useContext, useCallback, useEffect, useRef } from 'react';
import ConversationEvent from './src-components-ConversationEvent-ConversationEvent.js';
import MessageComponent from './src-components-MessageComponent-MessageComponent.js';
import TypingIndicator from './src-components-TypingIndicator-TypingIndicator.js';
import { shouldShowAdditionalDetails } from './src-utils-component-utils.js';
import { CAContext } from './src-contexts-CAContext.js';
import './src-components-ChatWindow-ChatWindowContent-ChatWindowContent.styles.scss.js';
import { useScrollLockInsideContainer } from './src-hooks-custom-hooks-useScrollLockInsideContainer.js';

const ChatWindowContent = ({ conversationMessages }) => {
  const { setChatState } = useContext(CAContext);
  const scrollToBottomOfChat = useCallback((elementId) => {
    setTimeout(() => {
      if (typeof document === "undefined") return;
      let chatBox = null;
      chatBox = document.getElementById("chatWindow");
      if (chatBox) {
        if (elementId) {
          const targetElement = document.getElementById(elementId);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
              // Center the element in the view
              inline: "nearest"
            });
            return;
          }
        }
        chatBox.scrollTo({
          top: chatBox.scrollHeight + 16,
          behavior: "smooth"
        });
      }
    }, 100);
  }, []);
  useEffect(() => {
    setChatState((prev) => ({ ...prev, scrollToBottom: scrollToBottomOfChat }));
  }, [scrollToBottomOfChat]);
  useEffect(() => {
    scrollToBottomOfChat();
  }, [conversationMessages, scrollToBottomOfChat]);
  const chatRef = useRef(null);
  useScrollLockInsideContainer(chatRef);
  return /* @__PURE__ */ React.createElement(Box, { className: `chatWindowBodyContainer`, id: "chatWindow", ref: chatRef }, conversationMessages.map((item, index) => {
    const isLastMessage = shouldShowAdditionalDetails(conversationMessages, index);
    if (item.type === "Typing") {
      if (typeof item.messageContent === "string") {
        return /* @__PURE__ */ React.createElement(
          MessageComponent,
          {
            id: item.id,
            key: item.id,
            messageContent: /* @__PURE__ */ React.createElement(TypingIndicator, { senderType: "agent", key: item.id }),
            messageType: "agent",
            isLastMessage: true,
            additionalComponents: item.additionalComponents,
            isMessageRead: item.isMessageRead,
            attachments: item.attachments,
            formatType: item.formatType
          }
        );
      } else {
        return item.messageContent;
      }
    }
    if (item.type === "system") {
      return /* @__PURE__ */ React.createElement(ConversationEvent, { key: item.id, eventDetails: item.messageContent, timeStamp: item.timestamp });
    }
    return /* @__PURE__ */ React.createElement(
      MessageComponent,
      {
        id: item.id,
        key: item.id,
        messageContent: item.messageContent,
        messageType: item.type,
        isLastMessage,
        footer: {
          isVisible: isLastMessage,
          agentName: item.type !== "user" ? item.senderDisplayName : void 0,
          timeStamp: item.timestamp
        },
        additionalComponents: item.additionalComponents,
        isMessageRead: item.isMessageRead,
        urlMapping: item.urlMapping,
        customMessageType: item.customMessageType,
        showFeedback: item.showFeedback,
        attachments: item.attachments,
        formatType: item.formatType
      }
    );
  }));
};

export { ChatWindowContent as default };
//# sourceMappingURL=src-components-ChatWindow-ChatWindowContent-ChatWindowContent.js.map
